<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!--table-->
        <div>
          <div class="row" id="divMainFilter">
            <button type="button" id="btnDepartmentsListByBUHead" (click)="DepartmentsListByBUHead()" style="display:none">GetDeliveryMethods</button>
            <button type="button" id="btnUsersListByBUHeadAndDepartmentList" (click)="UsersListByBUHeadAndDepartmentList()" style="display:none">GetDeliveryMethods</button>
            <div class="col-sm-4">
              <label>BU Head<em>*</em></label>
              <select id="ddlBUHeadList" class="form-control" multiple onchange="$('#btnDepartmentsListByBUHead').trigger('click');">
                <option *ngFor="let item of BUHeadList" [value]="item.BUHeadID">{{ item.BUHeadLoginName }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <label>Department<em>*</em></label>
              <select id="ddlDepartmentList" class="form-control" multiple onchange="$('#btnUsersListByBUHeadAndDepartmentList').trigger('click');">
                <option *ngFor="let item of DepartmentsList" [value]="item.DepartmentId">{{ item.DepartmentName }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <label>User<em>*</em></label>
              <select id="ddlUsersList" class="form-control" multiple>
                <option *ngFor="let item of UsersList" [value]="item.UserID">{{ item.LoginName }}</option>
              </select>
            </div>
            <div class="col-sm-3">
              <label>Status Type</label>
              <select id="ddlApprovedStatus" class="form-control">
                <option selected value="All">All</option>
                <option value="Waiting for Approval">Waiting for Approval</option>
                <option value="Need More Info">Need More Info</option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="FromDate" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="ToDate" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>

            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnLoadList" title="Get" (click)="GetweightageuserReportMastersData()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <table #dataTable class="display" style="width:100%"></table>
      </div>

    </div>
  </div>
</div>
